export const hereMapsApiPaths = {
  addressAutosuggest: 'https://autosuggest.search.hereapi.com/v1/autosuggest',
  reverseGeocode: 'https://revgeocode.search.hereapi.com/v1/revgeocode',
  calculateRoutes: 'https://router.hereapi.com/v8/routes',
  geocode: 'https://geocode.search.hereapi.com/v1/geocode',
  lookup: 'https://lookup.search.hereapi.com/v1/lookup',
} as const;

export const getHereMapsApiUrl = {
  addressAutosuggest: () => hereMapsApiPaths.addressAutosuggest,
  reverseGeocode: () => hereMapsApiPaths.reverseGeocode,
  calculateRoutes: () => hereMapsApiPaths.calculateRoutes,
  geocode: () => hereMapsApiPaths.geocode,
  lookup: () => hereMapsApiPaths.lookup,
};
